require('./bootstrap');
require('./toggle');
import $ from 'jquery';
import toastr from 'toastr';


$(document).ready(function () {

    $('.loader').fadeOut(1200);
    $('.dark-mode').on('click', function () {
        if ($('.dark-mode span').html() === 'dark_mode') {
            $('body').addClass('dark')
            $('.dark-mode span').html('light_mode')
            localStorage.setItem('mode', document.body.classList)
        } else if ($('.dark-mode span').html() === 'light_mode') {
            $('body').removeClass('dark')
            $('.dark-mode span').html('dark_mode')
            localStorage.removeItem('mode')
        }
    })

    if (localStorage.getItem('mode') == 'dark') {
        $('.mode').html('light_mode')
        document.body.classList.add(localStorage.getItem('mode'))
    } else {
        $('.dark-mode span').html('dark_mode')
    }
});


$(function () {
    $('#new-user').on('click', function (event) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let formData = {
            email: $('#newUserEmail').val(),
            password: $('#newUserPassword').val(),
            passwordRepeat: $('#newUserPassword1').val()
        }
        let ajaxUrl = $("#new-user").data("action")
        let token = $('meta[name="csrf-token"]').attr('content')
        let type = 'POST'
        $.ajax({
            type: type,
            url: ajaxUrl,
            data: formData,
            success: function (response) {
                if (response.error) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.error(response.error)
                } else if (response.success) {
                    $('#newUserEmail').val('')
                    $('#newUserPassword').val('')
                    $('#newUserPassword1').val('')
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "2000",
                        "hideDuration": "2000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.success(response.success)
                    $('#signInBtn').click();
                }

            },
            error: function (response) {
                toastr.error(response.error);
            }
        });
    })
})

$('#signUp').keypress(function (event) {
    let keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let formData = {
            email: $('#newUserEmail').val(),
            password: $('#newUserPassword').val(),
            passwordRepeat: $('#newUserPassword1').val()
        }
        let ajaxUrl = $("#new-user").data("action")
        let token = $('meta[name="csrf-token"]').attr('content')
        let type = 'POST'
        $.ajax({
            type: type,
            url: ajaxUrl,
            data: formData,
            success: function (response) {
                if (response.error) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.error(response.error)
                } else if (response.success) {
                    $('#newUserEmail').val('')
                    $('#newUserPassword').val('')
                    $('#newUserPassword1').val('')
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "2000",
                        "hideDuration": "2000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.success(response.success)
                    $('#signInBtn').click();
                }

            },
            error: function (response) {
                toastr.error(response.error);
            }
        });
    }
})
$("#visiblePassword").on('click', function () {
    let newUserPassword = $('#newUserPassword')
    if (newUserPassword.attr("type") == "password") {
        newUserPassword.attr("type", "text");
    } else {
        newUserPassword.attr("type", "password");
    }
})

$("#visiblePassword1").on('click', function () {
    let newUserPassword = $('#newUserPassword1')
    if (newUserPassword.attr("type") == "password") {
        newUserPassword.attr("type", "text");
    } else {
        newUserPassword.attr("type", "password");
    }
})

$("#visiblePassword2").on('click', function () {
    let newUserPassword = $('#loginPassword')
    if (newUserPassword.attr("type") == "password") {
        newUserPassword.attr("type", "text");
    } else {
        newUserPassword.attr("type", "password");
    }
})

$("#visiblePassword3").on('click', function () {
    let newUserPassword = $('#passwordChange1')
    if (newUserPassword.attr("type") == "password") {
        newUserPassword.attr("type", "text");
    } else {
        newUserPassword.attr("type", "password");
    }
})
$("#visiblePassword4").on('click', function () {
    let newUserPassword = $('#passwordChange2')
    if (newUserPassword.attr("type") == "password") {
        newUserPassword.attr("type", "text");
    } else {
        newUserPassword.attr("type", "password");
    }
})

$("#visiblePassword5").on('click', function () {
    let newUserPassword = $('#passwordChange3')
    if (newUserPassword.attr("type") == "password") {
        newUserPassword.attr("type", "text");
    } else {
        newUserPassword.attr("type", "password");
    }
})


$(function () {
    $('#user-login').on('click', function (event) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let formData = {
            email: $('#loginEmail').val(),
            password: $('#loginPassword').val(),
        }
        let ajaxUrl = $("#user-login").data("action")
        let token = $('meta[name="csrf-token"]').attr('content')
        let type = 'POST'
        $.ajax({
            type: type,
            url: ajaxUrl,
            data: formData,
            success: function (response) {
                if (response.error) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.error(response.error)
                } else if (response.success) {
                    $('#newUserEmail').val('')
                    $('#newUserPassword').val('')
                    $('#newUserPassword1').val('')
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "2000",
                        "hideDuration": "2000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.success(response.success)
                    setTimeout(function () {
                        $(location).attr('href', 'profile')
                    }, 1500);


                }

            },
            error: function (response) {
                toastr.error(response.error);
            }
        });
    })
})
$('#signIn').keypress(function () {
    let keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let formData = {
            email: $('#loginEmail').val(),
            password: $('#loginPassword').val(),
        }
        let ajaxUrl = $("#user-login").data("action")
        let token = $('meta[name="csrf-token"]').attr('content')
        let type = 'POST'
        $.ajax({
            type: type,
            url: ajaxUrl,
            data: formData,
            success: function (response) {
                if (response.error) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.error(response.error)
                } else if (response.success) {
                    $('#newUserEmail').val('')
                    $('#newUserPassword').val('')
                    $('#newUserPassword1').val('')
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "2000",
                        "hideDuration": "2000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.success(response.success)
                    setTimeout(function () {
                        let url = $('link[rel="url"]').attr('href')
                        $(location).attr('href', url + '/profile')
                    }, 1500);


                }

            },
            error: function (response) {
                toastr.error(response.error);
            }
        });
    }
})
//PDF TO WORLD
$('#pdf-to-word').on('change', function (e) {
    e.preventDefault()
    $('#pdf-to-word-form').submit(function (event) {
        if ($("#pdf-to-word").val() !== '') {
            event.preventDefault()
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            let formData = new FormData(this)
            let ajaxUrl = $("#pdf-to-word").data("action")
            let token = $('meta[name="csrf-token"]').attr('content')
            let type = 'POST'
            $.ajax({
                type: type,
                url: ajaxUrl,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                enctype: 'multipart/form-data',
                beforeSend: function () {
                    $('#pdf-to-word-form').hide()
                    $('#load').show()
                },
                success: function (response) {
                    if (response.error) {
                        $('#load').hide()
                        $('#error').show()
                        $('.errorMessage').text(response.error)
                        $('.download-file').hide()
                    } else if (response.success) {
                        $('#load').hide()
                        $('#result').show()
                        $("#download-files").attr("href", response.success)
                    } else if (response.premium) {
                        $('#load').hide()
                        $('#error').show()
                        $('.errorMessage').text(response.premium)
                    }

                },
                error: function (response) {
                    toastr.error(response.error);
                }
            });
        }
    })

    $('#pdf-to-world-btn').click();
})


$('#pdf-to-multiple-input').on('change', function (e) {
    e.preventDefault()
    $('#pdf-to-multiple').submit(function (event) {
        if ($("#pdf-to-multiple-input").val() !== '') {
            event.preventDefault()
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            let formData = new FormData(this)
            let ajaxUrl = $("#pdf-to-multiple-input").data("action")
            let token = $('meta[name="csrf-token"]').attr('content')
            let type = 'POST'
            $.ajax({
                type: type,
                url: ajaxUrl,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                enctype: 'multipart/form-data',
                beforeSend: function () {
                    $('#pdf-to-multiple').hide()
                    $('#load').show()
                },
                success: function (response) {
                    if (response.error) {
                        $('#load').hide()
                        $('#error').show()
                        $('.errorMessage').text(response.error)
                        $('.download-file').hide()
                    } else if (response.success) {
                        $('#load').hide()
                        $('#result').show()
                        $("#download-files").attr("href", response.success)

                    } else if (response.premium) {
                        $('#load').hide()
                        $('#error').show()
                        $('.errorMessage').text(response.premium)
                    }

                },
                error: function (response) {
                    toastr.error(response.error);
                }
            });
        }
    })

    $('#pdf-to-world-btn').click();
})


$('#uploadUrlBtn').on('click', function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    let formData = {
        uploadUrl: $('#uploadUrl').val()
    }
    let ajaxUrl = $("#pdf-to-word").data("action")
    let token = $('meta[name="csrf-token"]').attr('content')
    let type = 'POST'
    $.ajax({
        type: type,
        url: ajaxUrl,
        data: formData,
        beforeSend: function () {
            $('#pdf-to-word-form').hide()
            $('#load').show()
        },
        success: function (response) {
            if (response.error) {
                $('#load').hide()
                $('#error').show()
                $('.errorMessage').text(response.error)
                $('.download-file').hide()
            } else if (response.success) {
                $('#load').hide()
                $('#result').show()
                $("#download-files").attr("href", response.success)
            } else if (response.premium) {
                $('#load').hide()
                $('#error').show()
                $('.errorMessage').text(response.premium)
            }

        },
        error: function (response) {
            toastr.error(response.error);
        }
    });
})

$(function () {
    $('#password-change').on('click', function (event) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let formData = {
            oldPassword: $('#passwordChange1').val(),
            newPassword: $('#passwordChange2').val(),
            newPasswordR: $('#passwordChange3').val()
        }
        let ajaxUrl = $("#password-change").data("action")
        let token = $('meta[name="csrf-token"]').attr('content')
        let type = 'POST'
        $.ajax({
            type: type,
            url: ajaxUrl,
            data: formData,
            success: function (response) {
                if (response.error) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.error(response.error)
                } else if (response.success) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "2000",
                        "hideDuration": "2000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.success(response.success)


                }

            },
            error: function (response) {
                toastr.error(response.error);
            }
        });
    })
})
$(function () {
    $('#resetPassword').on('click', function (event) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        let formData = {
            email: $('#resetEmail').val()
        }
        let ajaxUrl = $("#resetPassword").data("action")
        let token = $('meta[name="csrf-token"]').attr('content')
        let type = 'POST'
        $.ajax({
            type: type,
            url: ajaxUrl,
            data: formData,
            success: function (response) {
                if (response.error) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.error(response.error)
                } else if (response.success) {
                    toastr.options = {
                        "closeButton": false,
                        "debug": false,
                        "newestOnTop": false,
                        "progressBar": false,
                        "positionClass": "toast-bottom-full-width mb-5",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "2000",
                        "hideDuration": "2000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    }
                    toastr.success(response.success)


                }

            },
            error: function (response) {
                toastr.error(response.error);
            }
        });
    })
})
let url = $('link[rel="canonical"]').attr('href')



$('#premiumForm').on('submit', function (e) {
    e.preventDefault();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    let formData = {
        pack: $('input[name="pack"]:checked').val(),
        premiumNameSurname: $('#premiumNameSurname').val(),
        premiumPhone: $('#premiumPhone').val(),
        premiumCountry: $('#premiumCountry').val(),
        premiumState: $('#premiumState').val(),
        premiumAdress: $('#premiumAdress').val(),
        premiumCity: $('#premiumCity').val(),
        txnamount: $('input[name="pack"]:checked').val() * 100
    }
    let ajaxUrl = $("#premiumBtnSubmit").data("action")
    let token = $('meta[name="csrf-token"]').attr('content')
    let type = 'POST'
    $.ajax({
        type: type,
        url: ajaxUrl,
        data: formData,
        success: function (response) {
            if (response.error) {
                toastr.options = {
                    "closeButton": false,
                    "debug": false,
                    "newestOnTop": false,
                    "progressBar": false,
                    "positionClass": "toast-bottom-full-width mb-5",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "300",
                    "hideDuration": "1000",
                    "timeOut": "5000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                }
                toastr.error(response.error)
            } else if (response.success) {
                toastr.options = {
                    "closeButton": false,
                    "debug": false,
                    "newestOnTop": false,
                    "progressBar": false,
                    "positionClass": "toast-bottom-full-width mb-5",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "2000",
                    "hideDuration": "2000",
                    "timeOut": "5000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                }
                $('input[name="mode"]').val(response.success.strMode);
                $('input[name="apiversion"]').val(response.success.strApiVersion);
                $('input[name="terminalprovuserid"]').val(response.success.strTerminalProvUserID);
                $('input[name="txntype"]').val(response.success.strType);
                $('input[name="txnamount"]').val(response.success.strAmount);
                $('input[name="txncurrencycode"]').val(response.success.strCurrencyCode);
                $('input[name="txninstallmentcount"]').val(response.success.strInstallmentCount);
                $('input[name="terminaluserid"]').val(response.success.strTerminalUserID);
                $('input[name="orderid"]').val(response.success.strOrderID);
                $('input[name="customeripaddress"]').val(response.success.strCustomeripaddress);
                $('input[name="customeremailaddress"]').val(response.success.strcustomeremailaddress);
                $('input[name="terminalid"]').val(response.success.strTerminalID);
                $('input[name="terminalmerchantid"]').val(response.success.strTerminalMerchantID);
                $('input[name="successurl"]').val(response.success.strSuccessURL);
                $('input[name="errorurl"]').val(response.success.strErrorURL);
                $('input[name="secure3dhash"]').val(response.success.HashData);
                $('input[name="premiumAdress"]').val(response.success.user_adress);
                $('input[name="premiumCountry"]').val(response.success.user_country);
                $('input[name="premiumNameSurname"]').val(response.success.user_full_name);
                $('input[name="premiumPhone"]').val(response.success.user_phone);
                $('input[name="premiumState"]').val(response.success.user_state);
                $('input[name="premiumCity"]').val(response.success.user_city);
                $('input[name="premiumPack"]').val(response.success.package);
                $('#premiumBtnSubmit').click();
            }

        },
        error: function (response) {
            toastr.error(response.error);
        }
    });
    $('#paySpan').text($('input[name="pack"]:checked').val());


})
/*
let siteLang = $('html').attr('lang');
let lang = navigator.language;
if (!localStorage.getItem('lang')) {
    if (siteLang !== lang) {
        $(location).attr('href', url + '/' + lang)
        let langSetting = localStorage.setItem('lang', lang)
    }
}
if (localStorage.getItem('lang') !== lang) {
    $(location).attr('href', url + '/' + lang)
    let langSetting = localStorage.setItem('lang', lang)
}
*/

